<template>
  <fieldset class="card">
    <div class="card-header">
      Lifestyle
    </div>
    <div class="card-body">
      <div class="row form-group">
        <div class="col-md-5 text-md-right">
          <label for="assessment-lifestyle-sleep-days-6-8">
            <strong>How many days a week do you get 6 to 8 hours of sleep a night?</strong>
          </label>
        </div>
        <div class="col-md-2">
          <div class="input-group">
            <input
              id="assessment-lifestyle-sleep-days-6-8"
              v-model="lifestyle_sleep_days_6_8_hours"
              type="number"
              step="1"
              min="0"
              max="7"
              class="form-control"
            >
            <div class="input-group-append">
              <div class="input-group-text">
                day(s)
              </div>
            </div>
          </div>
        </div>
      </div>
                
      <div class="form-group row">
        <div class="col-md-5 text-md-right">
          <label>
            <strong>Please select one of the options that best represents your smoking habits:</strong>
          </label>
        </div>
        <div class="col-md-7">
          <div class="form-check">
            <input
              id="assessment-lifestyle-smoking-last-smoked-never"
              v-model="lifestyle_smoking_last_smoked"
              class="form-check-input"
              name="assessment_lifestyle_smoking_last_smoked"
              type="radio"
              value="never"
              required
            >
            <label
              class="form-check-label"
              for="assessment-lifestyle-smoking-last-smoked-never"
            >
              I have never smoked.
            </label>
          </div>
          <div class="form-check">
            <input
              id="assessment-lifestyle-smoking-last-smoked-over-2-years"
              v-model="lifestyle_smoking_last_smoked"
              class="form-check-input"
              name="assessment_lifestyle_smoking_last_smoked"
              type="radio"
              value="over-2-years"
              required
            >
            <label
              class="form-check-label"
              for="assessment-lifestyle-smoking-last-smoked-over-2-years"
            >
              I quit smoking 2 or more years ago.
            </label>
          </div>
          <div class="form-check">
            <input
              id="assessment-lifestyle-smoking-last-smoked-1-2-years"
              v-model="lifestyle_smoking_last_smoked"
              class="form-check-input"
              name="assessment_lifestyle_smoking_last_smoked"
              type="radio"
              value="1-2-years"
              required
            >
            <label
              class="form-check-label"
              for="assessment-lifestyle-smoking-last-smoked-1-2-years"
            >
              I quit smoking 1 to 2 years ago.
            </label>
          </div>
          <div class="form-check">
            <input
              id="assessment-lifestyle-smoking-last-smoked-6-12-months"
              v-model="lifestyle_smoking_last_smoked"
              class="form-check-input"
              name="assessment_lifestyle_smoking_last_smoked"
              type="radio"
              value="6-12-months"
              required
            >
            <label
              class="form-check-label"
              for="assessment-lifestyle-smoking-last-smoked-6-12-months"
            >
              I quit smoking 6 to 12 months ago.
            </label>
          </div>
          <div class="form-check">
            <input
              id="assessment-lifestyle-smoking-last-smoked-0-5-months"
              v-model="lifestyle_smoking_last_smoked"
              class="form-check-input"
              name="assessment_lifestyle_smoking_last_smoked"
              type="radio"
              value="0-5-months"
              required
            >
            <label
              class="form-check-label"
              for="assessment-lifestyle-smoking-last-smoked-0-5-months"
            >
              I quit smoking in the past 6 months.
            </label>
          </div>
          <div class="form-check">
            <input
              id="assessment-lifestyle-smoking-last-smoked-current"
              v-model="lifestyle_smoking_last_smoked"
              class="form-check-input"
              name="assessment_lifestyle_smoking_last_smoked"
              type="radio"
              value="current"
              required
            >
            <label
              class="form-check-label"
              for="assessment-lifestyle-smoking-last-smoked-current"
            >
              I currently smoke cigarettes or use smokeless tobacco.
            </label>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-5 text-md-right">
          <i
            v-tooltip:top="'One drink = a 12 oz. beer, 5 oz. wine or 1.5 oz. liquor'"
            class="fa fa-info-circle text-primary d-inline"
          />
          <label
            class="d-inline"
            for="assessment-lifestyle-alcohol-drinks-weekly"
          >
            <strong>How many alcoholic drinks do you typically consume each week?</strong>
          </label>
        </div>
        <div class="col-md-4 col-lg-3">
          <div class="input-group">
            <input
              id="assessment-lifestyle-alcohol-drinks-perweek"
              v-model="lifestyle_alcohol_drinks_perweek"
              type="number"
              step="1"
              min="0"
              class="form-control"
            >
            <div class="input-group-append">
              <div class="input-group-text">
                drink(s)
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-5 text-md-right">
          <i
            v-tooltip:top="'A single sitting is defined by the CDC as 2 hours or less.'"
            class="fa fa-info-circle text-primary d-inline"
          />
          <label class="d-inline">
            <strong>Have you had 5 or more alcoholic drinks in a single sitting in the last 6 months?</strong>
          </label>
        </div>
        <div class="col-md-7">
          <div class="form-check form-check-inline">
            <input
              id="assessment-lifestyle-alcohol-5-single-sitting-last-6-mos-yes"
              v-model="lifestyle_alcohol_five_single_sitting_last_6_months"
              class="form-check-input"
              name="assessment_lifestyle_alcohol_5_single_sitting_last_6_mos"
              type="radio"
              value="1"
              required
            >
            <label
              class="form-check-label"
              for="assessment-lifestyle-alcohol-5-single-sitting-last-6-mos-yes"
            >
              Yes
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              id="assessment-lifestyle-alcohol-5-single-sitting-last-6-mos-no"
              v-model="lifestyle_alcohol_five_single_sitting_last_6_months"
              class="form-check-input"
              name="assessment_lifestyle_alcohol_5_single_sitting_last_6_mos"
              type="radio"
              value="0"
              required
            >
            <label
              class="form-check-label"
              for="assessment-lifestyle-alcohol-5-single-sitting-last-6-mos-no"
            >
              No
            </label>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'GET_DATA_FIELD',
  mutationType: 'UPDATE_DATA_FIELD',
});

export default {
  computed: {
    ...mapFields('healthData', {
      'lifestyle_sleep_days_6_8_hours': 'lifestyle.sleep.days_6_8_hours',
      'lifestyle_alcohol_drinks_perweek': 'lifestyle.alcohol.drinks_perweek',
      'lifestyle_alcohol_five_single_sitting_last_6_months': 'lifestyle.alcohol.five_single_sitting_last_6_months',
      'lifestyle_smoking_last_smoked': 'lifestyle.smoking.last_smoked',
    })
  }
}
</script>
